module.exports = __webpack_public_path__ + "assets/cover_1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_1.jpg
 ** module id = 109
 ** module chunks = 1
 **/